import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import Header from '../layout/Header';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Keyboard from '../_app/cuchillo/core/Keyboard';

export default class NoScroll extends Default {
  constructor() {
    super();
  }

  //SHOW
  beforeShow() {
    document.body.classList.add('__noScroll');

    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: false, multiplicator: 1 });
    Keyboard.mountPage(this.id);

    if (this.isFirstTime) {
      Header.show();
    }
  }

  afterShow() {
    this._isActive = true;
    Scroll.show();

    if (this.isFirstTime) Header.hideLogo();
  }

  beforeHide() {
    super.beforeHide();
    document.body.classList.remove('__noScroll');
  }
}

ControllerPage._addPage('no-scroll', NoScroll);
